<ng-container [appWorkflowItem]="workflowItem" [appWorkflowItemData]>
	<workflow-compact-questionpage *ngIf="viewMode === 'compact'">
	</workflow-compact-questionpage>
	<nz-modal *ngIf="viewMode === 'wizard' && currentNode && currentPage" nzVisible nzNoAnimation>
		<workflow-wizard-questionpage [currentNode]="currentNode" [page]="currentPage">
		</workflow-wizard-questionpage> 
	</nz-modal>
</ng-container>

